// extracted by mini-css-extract-plugin
export default {"city":"a1XFd","external":"b1XFd","region":"c1XFd","list":"d1XFd","name":"e1XFd"};